import { OrderListDetails } from '@shared/models/delivery/delivery.model';

export function getDeliveryRowUomDisplay(row: OrderListDetails): string {
  const firstLineItem = row.orderLineItems?.[0];

  return row.uomCode ?? firstLineItem?.uomCode ?? row.uom ?? firstLineItem?.uom ?? '';
}

export function normalizeDeliveryRow(row: OrderListDetails): OrderListDetails {
  const firstLineItem = row.orderLineItems?.[0];

  return {
    ...row,
    tickref: row.tickref ?? row.itemNumber ?? '',
    productId: row.productId ?? firstLineItem?.productId,
    productName: row.productName ?? row.product ?? firstLineItem?.name ?? '',
    uom: getDeliveryRowUomDisplay(row),
    totalConfirmedPrice: row.totalConfirmedPrice ?? row.totalPrice,
    totalConfirmedQuantity: row.totalConfirmedQuantity ?? row.totalOrderQuantity,
    deliveryMethod: row.deliveryMethod ?? row.orderSource ?? '',
  };
}

export function normalizeDeliveryRows(rows: OrderListDetails[]): OrderListDetails[] {
  return rows.map((row) => normalizeDeliveryRow(row));
}

export function recomputeDeliveryStatusTotals(orderList: OrderListDetails[]) {
  return {
    requestedTotal: orderList.filter((row) => row.orderStatus === 'NEW').length,
    scheduledTotal: orderList.filter((row) => row.orderStatus === 'SCHEDULED').length,
    forDeliveryTotal: orderList.filter((row) => row.orderStatus === 'OUT_FOR_DELIVERY').length,
    deliveredTotal: orderList.filter((row) =>
      row.orderStatus === 'COMPLETED' || row.orderStatus === 'COMPLETE'
    ).length,
  };
}
